import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { MaskLines, Reveal } from "@/components/motion/Reveal";
import { COMPANY, IMG } from "@/data/site";
import { Magnetic } from "@/components/fx/Motion";

export const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);
  return (
    <section ref={ref} className="relative overflow-hidden border-t border-white/5 py-32 lg:py-48" data-testid="final-cta-section">
      <motion.img style={{ y, scale: 1.3 }} src={IMG.arcadeRed} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink-950 via-ink-950/85 to-ink-950/40" />
      <div className="container-x relative">
        <p className="eyebrow">Partner with Brewer</p>
        <h2 className="mt-6 max-w-5xl font-display text-4xl font-black uppercase leading-[0.92] tracking-[-0.035em] text-white sm:text-6xl lg:text-7xl">
          <MaskLines onView lines={["Give customers", <span key="a" className="text-outline">more reasons</span>, <>to stay<span className="text-volt">.</span></>]} />
        </h2>
        <Reveal delay={0.3} className="mt-12 flex flex-wrap gap-4">
          <Magnetic><Link to="/partner" className="btn-primary h-14 px-8 text-base" data-testid="final-cta-partner-button">Become a Partner <ArrowRight className="btn-arrow h-4 w-4" /></Link></Magnetic>
          <a href={COMPANY.tel} className="btn-ghost h-14 px-8 text-base" data-testid="final-cta-call-button"><Phone className="h-4 w-4 text-volt" /> {COMPANY.phone}</a>
        </Reveal>
      </div>
    </section>
  );
};
